import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface Props {
    email: string
    onResend: () => void
}

export default function EmailSentConfirmation({ email, onResend }: Props) {
    return (
        <Box sx={{ textAlign: 'center', py: 1 }}>
            <Box
                sx={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    bgcolor: '#EEF2FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2.5,
                }}
            >
                <MarkEmailReadOutlinedIcon sx={{ fontSize: 32, color: 'primary.light' }} />
            </Box>

            <Typography variant="h5" >
                Email enviado!
            </Typography>

            <Typography variant="body2" color="text.secondary">
                Enviámos um link de redefinição para
            </Typography>
            <Typography
                variant="body2"
                color="text.primary"
               
                sx={{
                    wordBreak: 'break-all',
                    px: 2,
                    py: 1,
                    bgcolor: '#F8FAFC',
                    borderRadius: 2,
                    border: '1px solid #E5E7EB',
                }}
            >
                {email}
            </Typography>

            <Typography variant="body2" color="text.secondary">
                Verifique a sua caixa de entrada e o spam. O link expira em{' '}
                <Box color="text.primary">
                    30 minutos
                </Box>
                .
            </Typography>

            <Button
                component={Link}
                to="/login"
                variant="contained"
                size="large"
                fullWidth
            >
                Voltar ao login
            </Button>

            <Button
                variant="text"
                size="large"
                fullWidth
                onClick={onResend}
                sx={{ mt: 1, color: 'text.secondary' }}
            >
                <ArrowBackIcon sx={{ fontSize: 16, mr: 0.5 }} />
                Usar outro email
            </Button>
        </Box>
    )
}
